import { render, staticRenderFns } from "./imageComponent.vue?vue&type=template&id=4da2b482&scoped=true&"
import script from "./imageComponent.vue?vue&type=script&lang=js&"
export * from "./imageComponent.vue?vue&type=script&lang=js&"
import style0 from "./imageComponent.vue?vue&type=style&index=0&id=4da2b482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da2b482",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
